import React from 'react';

interface IMultiBoldBulletListProps {
    items: {[key: string]: string}
    horizontal?: boolean;
    width?: string;
    maxBullets?: number;
    /** When given, each bullet is clickable and this receives its key and value. */
    onSelect?: (key: string, value: string) => void;
    /** Tooltip for a clickable bullet, built from its key and value. */
    selectTitle?: (key: string, value: string) => string;
}

/** Bullet columns in the horizontal layout (was three 30% items). */
const BULLET_COLUMNS = 3;

const MultiBoldBulletList: React.FC<IMultiBoldBulletListProps> = (props) => {

    const boldAll = (className: string) => {
        const elements = document.getElementsByClassName(className);
        // find all the elements with this class name and bold their text by applying a bullet-bold class
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.classList.add('bullet-bold');
        }
    }

    const unboldAll = (className: string) => {
        const elements = document.getElementsByClassName(className);
        // find all the elements with this class name and remove the bullet-bold class
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.classList.remove('bullet-bold');
        }
    }

    const convertToClassName = (key: string) => {
        return key.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
    }

    const itemsToDisplay = props.maxBullets ? Object.entries(props.items).slice(0, props.maxBullets) : Object.entries(props.items).slice(0, 9);

    // A grid at the full cell width, so the bullet columns land on the same x from row to row (a
    // shrink-to-fit flex layout let them drift with the name's length). Up to BULLET_COLUMNS
    // columns, but never narrower than 9em: in a narrow Name column, three columns of a few pixels
    // each wrapped every bullet letter by letter and tripled the row height. On a laptop screen that
    // swing made the page's scrollbar appear and disappear every frame (the scrollbar's width
    // re-fits the grid's columns).
    const layout: React.CSSProperties = props.horizontal
        ? {display: 'grid', gridTemplateColumns: `repeat(auto-fill, minmax(max(9em, calc((100% - ${BULLET_COLUMNS - 1}em) / ${BULLET_COLUMNS})), 1fr))`, columnGap: '1em', width: '100%'}
        : {display: 'flex', flexDirection: 'column', gap: '0.25em', width: props.width};

    return (<div style={layout}>
        {itemsToDisplay.map(([key, value]) => (
            <div
                key={key}
                className={`bullet bullet-${convertToClassName(key)}${props.onSelect ? ' bullet-clickable' : ''}`}
                title={props.onSelect && props.selectTitle ? props.selectTitle(key, value) : undefined}
                onMouseEnter={() => boldAll(`bullet-${convertToClassName(key)}`)}
                onMouseLeave={() => unboldAll(`bullet-${convertToClassName(key)}`)}
                onClick={props.onSelect ? (e) => { e.stopPropagation(); props.onSelect?.(key, value); } : undefined}
                >
                &bull; {key} {value !== 'YES' ? `: ${value}` : ''}
            </div>
        ))}
    </div>);
}

export default MultiBoldBulletList;